export const getQueryData = (compareList: string) => {
  try {
    if (compareList.includes('A')) {
      const parts = compareList.split('/');
      const ids: Array<string> = [];
      for (let idx = 1; idx < parts.length; idx++) {
        if (parts[idx]) {
          ids.push(`PY-A-${parts[idx]}`);
        }
      }
      return [...ids];
    } else if (compareList.includes('P')) {
      const parts = compareList.split('/');
      const ids: Array<string> = [];
      for (let idx = 1; idx < parts.length; idx++) {
        if (parts[idx]) {
          ids.push(`PY-P-${parts[idx]}`);
        }
      }
      return [...ids];
    } else if (compareList.includes('G')) {
      const parts = compareList.split('/');
      const ids: Array<string> = [];
      for (let idx = 1; idx < parts.length; idx++) {
        if (parts[idx]) {
          ids.push(`PY-${parts[idx]}`);
        }
      }
      return [...ids];
    }
    return [];
  } catch (error) {
    console.log('cant get compareListCookie', error);
    return [];
  }
};
